<script lang="ts">
  /**
   * BackButton - Navigation button to return to menu
   */

  // Props
  interface Props {
    onclick?: () => void;
  }

  let { onclick = () => {} }: Props = $props();
</script>

<button
  class="back-button"
  onclick={onclick}
  aria-label="Return to menu"
>
  <span class="icon">←</span>
  <span class="text">Back</span>
</button>

<style>
  .back-button {
    display: flex;
    align-items: center;
    gap: var(--space-sm);
    padding: var(--space-sm) var(--space-md);
    border: none;
    border-radius: var(--radius-md);
    background: rgba(10, 22, 40, 0.85);
    color: white;
    font-size: var(--font-lg);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }

  .back-button:hover {
    background: var(--color-cosmic-purple);
    transform: translateX(-4px);
  }

  .back-button:active {
    transform: translateX(-2px) scale(0.98);
  }

  .icon {
    font-size: 24px;
  }

  /* Responsive sizing */
  @media (max-width: 767px) {
    .back-button {
      padding: var(--space-xs) var(--space-sm);
      font-size: var(--font-body);
    }

    .icon {
      font-size: 20px;
    }

    .text {
      display: none;
    }
  }
</style>
